// extracted by mini-css-extract-plugin
export default {"container":"invalid-link_container__Kn46K","wrapper":"invalid-link_wrapper__R6b1R","navigation_link":"invalid-link_navigation_link__TePy7"};